import { render } from "./QuestionFeedbackPage.vue?vue&type=template&id=16f70ab8&scoped=true"
import script from "./QuestionFeedbackPage.vue?vue&type=script&lang=js"
export * from "./QuestionFeedbackPage.vue?vue&type=script&lang=js"

import "./QuestionFeedbackPage.vue?vue&type=style&index=0&id=16f70ab8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16f70ab8"]])

export default __exports__